<!-- edit mode -->
<ng-container *ngIf="editMode">
  <app-contact-details-form
    #cdForm
    [contactDetailsForm]="contactDetailsForm"
  ></app-contact-details-form>

  <div style="margin-top: 2.5rem">
    <app-home-address-form
      #haForm
      [homeAddressForm]="homeAddressForm"
    ></app-home-address-form>
  </div>

  <hr class="bottom-divider" />
  <footer class="footer-action">
    <button
      class="btn btn-danger btn-block"
      [disabled]="haForm.getForm().invalid || cdForm.getForm().invalid"
      (click)="exitEditMode()"
    >Save</button>
  </footer>
</ng-container>


<!-- view mode -->
<div *ngIf="!editMode">
  <app-content-header
    text="Contact Details"
    [showEdit]="!editMode"
    (editClicked)="enterEditMode()"
    firebase="myProfile_editContact"
  ></app-content-header>

  <div class="mb-2 mt-1">
    <div class="row">
      <div class="col view-container">
        <div class="view-label">
          Name
        </div>
        <span class="lato">
          {{ contactDetailsForm.value.firstName + ' ' + contactDetailsForm.value.lastName }}
        </span>
        <hr class="view-divider" />
      </div>
      <div class="w-100"></div>

      <div class="col view-container">
        <div class="view-label">
          Email Address
        </div>
        <span class="lato">
          {{ contactDetailsForm.value.email }}
        </span>
        <hr class="view-divider" />
      </div>
      <div class="w-100"></div>
    </div>

    <div
      class="row"
      *ngFor="let phone of contactDetailsForm.value.phones; index as i"
    >
      <div class="col view-container">
        <div class="view-label">
          {{ i === 0 ? 'Primary Phone Number' : 'Additional Phone Number' }}
        </div>
        <div class="row">
          <span class="col-8 lato">
            {{ '+' + phone.geoCountry.countryCallingCode + ' ' + (phone.phoneNumber | mask:'(000) 000-0000') }}
          </span>
          <span class="col-4 lato">
            {{ phone.phoneType.type }}
          </span>
        </div>
        <hr class="view-divider" />
      </div>
      <div class="w-100"></div>
    </div>
  </div>

  <app-content-header
    text="Home Address"
    [showEdit]="!editMode"
    (editClicked)="enterEditMode()"
    firebase="myProfile_editHomeAddress"
  ></app-content-header>

  <div class="row">
    <div class="col view-container">
      <div class="view-label">
        Country
      </div>
      <span class="lato">
        {{ homeAddressForm.value.country | country }}
      </span>
      <hr class="view-divider" />
    </div>
    <div class="w-100"></div>

    <div class="col view-container">
      <div class="view-label">
        Address
      </div>
      <span class="lato">
        {{ homeAddressForm.value.address1 }} {{ homeAddressForm.value.address2 }}
      </span>
      <hr class="view-divider" />
    </div>
    <div class="w-100"></div>
    <div class="col view-container">
      <div class="view-label">
        City
      </div>
      <span class="lato">
        {{ homeAddressForm.value.city }}
      </span>
      <hr class="view-divider" />
    </div>
    <div class="w-100"></div>

    <div class="col view-container">
      <div class="row">
        <div class="col">
          <div class="view-label">
            {{ homeAddressForm.value.country === 'us' ? 'State' : 'Province' }}
          </div>
        </div>
        <div class="col">
          <div class="view-label">
            {{ homeAddressForm.value.country === 'us' ? 'ZIP Code' : 'Postal Code' }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col lato">
          {{ homeAddressForm.value.stateProvince | stateProvince: homeAddressForm.value.country}}
        </div>
        <div class="col lato">
          {{ homeAddressForm.value.postalCode }}
        </div>
      </div>
      <span>
      </span>
      <hr class="view-divider" />
    </div>
  </div>
</div>